<template>
  <div class="welcome-banner" :style="bgImage ? { backgroundImage: `url(${bgImage})` } : {}">
    <div class="banner-overlay">
      <div class="banner-content">
        <h1 class="banner-title">{{ title }}</h1>
        <p class="banner-desc">{{ subTitle }}</p>
        <el-button class="learn-more-btn" @click="goToFiveNav">
          LEARN MORE
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { leftLikeDict } from "@/api/system";
import Constant from "@/utils/Constant";

export default {
  data() {
    return {
      title: "",
      subTitle: "",
      bgImage: "",
    };
  },
  methods: {
    goToFiveNav() {
      this.$router.push('/fivenav/1').catch(() => {});
    },
    async leftLikeDictFunc() {
      try {
        const res = await leftLikeDict(Constant.HOME_ABOUTUS);

        // -------------- 核心修复：正确解析数据 --------------
        const list = res.data?.data || [];

        const titleItem = list.find(item => item.dictKey === "home_aboutusTitle");
        const subTitleItem = list.find(item => item.dictKey === "home_aboutusSubTitle");
        const imageItem = list.find(item => item.dictKey === "home_aboutusImage");

        this.title = titleItem?.dictValue || "";
        this.subTitle = subTitleItem?.dictValue || "";
        this.bgImage = imageItem?.dictValue || "";

      } catch (e) {
        console.error("leftLikeDictFunc error:", e);
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc();
  }
};
</script>

<style lang="scss" scoped>
.welcome-banner {
  width: 100%;
  height: 700px;
  background: linear-gradient(135deg, #6f063f 0%, #880f53 50%, #992667 100%);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 500px;
  }

  .banner-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .banner-content {
    max-width: 85%;
    text-align: center;
    color: #fff;

    .banner-title {
      font-size: 55px;
      font-weight: bold;
      margin: 0 0 20px;
      font-family: 'Roboto_Bold', sans-serif;

      @media (max-width: 768px) {
        font-size: 26px;
      }
    }

    .banner-desc {
      font-size: 29px;
      font-weight: bold;
      line-height: 1.6;
      margin: 0 auto 30px;
      max-width: 100%;
      font-family: 'Roboto', sans-serif;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }

    .learn-more-btn {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
      padding: 14px 40px;
      font-size: 16px;
      font-weight: bold;
      font-family: 'Roboto_Bold', sans-serif;
      border-radius: 0;
      transition: all 0.3s ease;

      @media (max-width: 768px) {
        padding: 12px 30px;
        font-size: 14px;
      }

      &:hover {
        background: #fff;
        color: #880f53;
      }
    }
  }
}
</style>